module.exports = __webpack_public_path__ + "static/media/img_succession_planning_03.1fbcb45c.png";